<template>
  <O3D><slot></slot></O3D>
</template>

<script>
// import { WoozyMaterial } from '../../Reusable/WoozyMaterial'
import { O3DG2 } from '../../Reusable/O3DG2'
import { CharNPC } from './CharNPC.js'

export default {
  mixins: [O3DG2],
  props: {
    matcap: {
      default: false
    },
    opacity: {
      default: 1
    },
    char: {
      default: undefined
    },
    dance: {
      default: undefined
    }
  },
  data () {
    return {
      npc: false
    }
  },
  methods: {
    setup () {
      this.npc = new CharNPC({ matcap: this.matcap, opacity: this.opacity, char: this.char, onLoop: this.onLoop, readyMoveName: this.dance, chroma: this.ctx.chroma })

      this.npc.out.done.then(() => {
        this.$emit('ready')
        this.o3d.add(this.npc.out.o3d)
        this.renderRoot.$emit('lookAtGuy', this.npc.skeleton.mixamorigHead)
      })

      this.o3d.children.forEach(k => {
        this.o3d.remove(k)
      })

      this.$root.$on('play-move', ({ name, randomDelay = 135 }) => {
        setTimeout(() => {
          this.npc.act({ name })
        }, randomDelay * Math.random())
      })

      this.$watch('dance', () => {
        this.npc.act({ name: this.dance })
      })
      this.$watch('opacity', () => {
        this.npc.setOpacity(this.opacity)
      })
      this.$watch('matcap', () => {
        if (this.matcap) {
          this.npc.setMatCap(this.matcap)
        }
      })
    }
  },
  mounted () {
    this.setup()
    this.$watch('char', () => {
      this.setup()
    })
  }
}

/*

Vision 5 Years and 1 Year
Weekly plan 1 3 5 release different content, 2 4 6 release different work
Income within 1year 5 years
Authoratative experiece in the structruing the code base in Front end, Threejs and Vuejs

*/
</script>

<style>

</style>
